import React, { useState } from 'react';
import Modal from './Modal';

const ProjectCard = ({ project }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="p-4 cursor-pointer">
      <div className="w-full h-[260px] lg:h-48 overflow-hidden rounded">
        <img
          src={project.image}
          alt={project.title}
          className="w-full h-full object-contain lg:object-cover cursor-pointer hover:scale-105 transition-transform"
          onClick={() => setIsModalOpen(true)}
        />
      </div>

      {isModalOpen && (
        <Modal project={project} onClose={() => setIsModalOpen(false)} />
      )}
    </div>
  );
};

export default ProjectCard;